import { Link } from "react-router";
import { ArrowRight, Images } from "lucide-react";

export function GalleryPage() {
  return (
    <div className="min-h-screen">
      <section className="py-20 bg-gradient-to-br from-background via-gray-50 to-green-50">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="inline-flex items-center gap-2 bg-accent/10 text-accent px-3 py-1 rounded-full text-sm font-medium mb-6">
            <Images className="size-4" aria-hidden />
            <span>Gallery</span>
          </div>
          <h1 className="text-6xl font-bold mb-6">Gallery</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mb-10">
            A visual showcase of our packaging, print work, and client projects. More imagery coming soon.
          </p>
          <Link
            to="/quote"
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-accent text-white transition-colors hover:bg-accent/90 px-8 py-4 font-medium shadow-lg shadow-accent/20"
          >
            Start a project
            <ArrowRight className="size-5" aria-hidden />
          </Link>
        </div>
      </section>

      <section className="py-24 bg-background">
        <div className="mx-auto max-w-5xl px-6 lg:px-8 text-center">
          <div className="mx-auto flex aspect-[21/9] max-w-4xl items-center justify-center rounded-3xl border border-dashed border-border bg-muted/30">
            <p className="text-muted-foreground">Gallery images will appear here.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
